import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl-next';

import Tooltip from '@atlaskit/tooltip';

import { useEditionAwareness } from '../../services/edition-awareness-context';
import { useGetExperimentValue } from '../../services/experiment-context';
import { isEligibleForEAtoOSBExperiment } from '../../services/is-eligible-for-ea-to-osb-experiment';
import { EditionAwarenessLink } from '../edition-awareness-button';

interface AddPaymentLinkProps {
	href: string;
}

export const AddPaymentLink = ({ href }: AddPaymentLinkProps): React.JSX.Element => {
	const context = useEditionAwareness();
	const { getExperimentValue } = useGetExperimentValue();

	const handleAddPaymentClick = useCallback(() => {
		// Fire exposure for ea_to_osb_experiment control tenants
		if (isEligibleForEAtoOSBExperiment(context)) {
			getExperimentValue({
				statsigParams: {
					experimentName: 'ea_to_osb_experiment',
					parameterName: 'cohort',
					defaultValue: 'not-enrolled',
				},
				trackEventParameters: {
					trackEventGrowthInitiative: 'tako',
				},
			});
		}
	}, [getExperimentValue, context]);

	return (
		<Tooltip
			content={
				<FormattedMessage
					id="@atlassian/edition-awareness.link.add-payment-tooltip"
					defaultMessage="Add payment details to keep your subscription"
					description="Tooltip for add payment details button"
				/>
			}
			position="bottom"
		>
			<EditionAwarenessLink
				href={href}
				target="_blank"
				touchpointIntent="addPaymentDetails"
				linkId="predunning"
				onClick={handleAddPaymentClick}
			/>
		</Tooltip>
	);
};
